<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"><a id="ch00_fm04"></a><a id="page_iv">This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously. Other names, characters, places, and incidents are the product of the author’s imagination, and any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.</a></p><a id="page_iv">
<p class="noindent2"><img alt="images" src="images/f00iv-01.jpg"/>ALADDIN PAPERBACKS</p>
<p class="noindentbm">An imprint of Simon &amp; Schuster Children’s Publishing Division</p>
</a><p class="noindentbm"><a id="page_iv">1230 Avenue of the Americas, New York, NY 10020<br/></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="noindentbm">Copyright © 2008 by Simon &amp; Schuster, Inc.</p>
<p class="noindentbm">All rights reserved, including the right of</p>
<p class="noindentbm">reproduction in whole or in part in any form.</p>
<p class="noindentbm">NANCY DREW, NANCY DREW: GIRL DETECTIVE, ALADDIN PAPERBACKS, and related logo are registered trademarks of Simon &amp; Schuster, Inc.</p>
<p class="noindentbm">Manufactured in the United States of America</p>
<p class="noindentbm">First Aladdin Paperbacks edition July 2008</p>
<p class="noindentbm">10   9   8   7   6   5   4   3   2   1  </p>
<p class="noindentbm">Library of Congress Control Number 2007934378</p>
<p class="noindentbm">ISBN-13: 978-1-4169-5530-6</p>
<p class="noindentbm">ISBN-10: 1-4169-5530-5</p>
<p class="noindentbm">eISBN-13: 978-1-4169-7948-7</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04.vue?6886379f